export default __webpack_public_path__ + "static/media/eight.6f838947.png";